import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';

import { PriorShift, PriorShiftServiceService } from '../services/prior-shift-service.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-remove-shift-dialog',
    templateUrl: './remove-shift-dialog.component.html',
    styleUrls: ['./remove-shift-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatDivider, MatFormField, MatLabel, MatInput, MatHint, MatDialogActions, MatButton, DatePipe]
})
export class RemoveShiftDialogComponent implements OnInit {
  shift:PriorShift;
  reasonFormGroup:UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<RemoveShiftDialogComponent>,
    private fb: UntypedFormBuilder,
    private svcShiftService: PriorShiftServiceService,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) { 
    this.shift = this.inData.Shift;

    this.reasonFormGroup = this.fb.group({
      Reason: new UntypedFormControl({value: "", disabled: false}, Validators.required)
    });

  }

  ngOnInit(): void {
    
  }

  removeShift():void {
    let reason:string = this.reasonFormGroup.get("Reason").value;
    this.svcShiftService.deleteShift(this.shift.ProjectID, this.shift.Area, this.shift.ShiftDate, this.shift.Shift, reason).subscribe( 
      out => {
        console.debug("Shift Deleted", out);
      }

    )
  }

  onNoClick():void {
    console.log("Close");
    this.dialogRef.close();
  }


}
